import { flexRender, type HeaderGroup, type RowData } from '@tanstack/react-table';

import { DimeTableHead, DimeTableHeader, DimeTableRow } from '../DimeTable/index.js';
import { cn } from '../lib/utils.js';
import { getAriaSort } from '../table-internals/get-aria-sort.js';
import { expandCellClass } from './expand-cell-class.js';
import type { DimeNestedTableFeatures } from './nested-table-features.js';

export function NestedTableHeader<TParent extends RowData>({
  headerGroups,
  sticky,
}: Readonly<{
  headerGroups: HeaderGroup<DimeNestedTableFeatures, TParent>[];
  sticky: boolean;
}>) {
  return (
    <DimeTableHeader sticky={sticky}>
      {headerGroups.map((headerGroup) => (
        <DimeTableRow key={headerGroup.id} className="hover:bg-transparent">
          {headerGroup.headers.map((header) => (
            <DimeTableHead
              key={header.id}
              aria-sort={getAriaSort(header.column)}
              className={cn(
                expandCellClass(header.column.id),
                header.column.columnDef.meta?.headerClassName,
              )}
            >
              {flexRender(header.column.columnDef.header, header.getContext())}
            </DimeTableHead>
          ))}
        </DimeTableRow>
      ))}
    </DimeTableHeader>
  );
}
